import mailGroupFilesRouteHandler from './mailGroupFilesRouteHandler';
import { mailSxSCleanupRouteHandler } from './mailSxSRouteHandler';
import type { MailGroupRouteParameters } from './utils/mailGroupRouteSettings';
import { resetSxSViewStore } from 'owa-groups-recent-files-store/lib/lazyFunctions';

export function mailGroupFilesSPCleanupRouteHandler(
    _oldRoute?: string[],
    /* eslint-disable-next-line owa-custom-rules/no-optional-any-parameter -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE! This code should be fixed by any developer touching this code
     *	> Optional function parameters should not have type "any". This can hide undefined/null references otherwise detectable by the transpiler. */
    _oldParameters?: any,
    _newRoute?: string[],
    /* eslint-disable-next-line owa-custom-rules/no-optional-any-parameter -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE! This code should be fixed by any developer touching this code
     *	> Optional function parameters should not have type "any". This can hide undefined/null references otherwise detectable by the transpiler. */
    _newParameters?: any
): boolean {
    resetSxSViewStore('browserNavigation');
    return false;
}

export async function mailGroupFilesSxSCleanupRouteHandler(): Promise<boolean> {
    return mailSxSCleanupRouteHandler();
}

export async function mailGroupFilesSXSNavigationRouteHandler(
    parameters: MailGroupRouteParameters,
    _allParameters?: string[] | undefined
): Promise<void> {
    await mailGroupFilesRouteHandler(parameters);
}
